// extracted by mini-css-extract-plugin
module.exports = {"Container":"Toggle_Container__lB7sa","Thumb":"Toggle_Thumb__RkQ1X","ThumbChecked":"Toggle_ThumbChecked__wTT05","ThumbUnchecked":"Toggle_ThumbUnchecked__Pfvv8"};